import { t } from '@lingui/core/macro';
import { Banner, Box } from '@pocketlaw/tetris';
function getText(accessLevel) {
    switch (accessLevel) {
        case 'traverse':
            return t({
                message: 'You have limited access to this folder. Only files shared directly with you are visible.',
                comment: 'Access warning alert message',
            });
        case 'read':
            return t({
                message: 'You have read-only access to this folder. You can view all content but cannot make changes or add new files.',
                comment: 'Access warning alert message',
            });
        case 'none':
        case 'full':
        default:
            return undefined;
    }
}
export function AccessInformation(props) {
    const { accessLevel } = props;
    const text = getText(accessLevel);
    if (!text) {
        return null;
    }
    return (<Box mb="lg" display="block">
      <Banner appearance="warning">{text}</Banner>
    </Box>);
}
